import React from "react";
const CardBgnNone = ({ title, description, maxWidth }) => {
  return (
    <div
      className="card border-primary bg-silver mb-3 ml-3"
      style={{ maxWidth: maxWidth + "rem" }}
    >
      <div className="card-header text-bold">{title}</div>
      <div className="card-body text-justify">
        <p className="card-text">{description}</p>
      </div>
    </div>
  );
};

export default CardBgnNone;
